// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1di4L","container":"Footer_container__Opq7B","links":"Footer_links__5aLza","copyright":"Footer_copyright__3dD2j","attribution":"Footer_attribution__hD76k"};